import { Page } from "@/models/page-models/Page";

export const NewSample: Page = {
  "path": "new-sample",
  "name": "New Sample",
  "props": {
    "data": {
      "title": "New Sample",
      "printable": "FALSE",
      "url": "new-sample",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.customer",
                  "label": "Select Customer",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyCustomerContacts",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject.contactDetails",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.contact"
                      },
                      "name": "copyCustomerContacts"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyCustomerData",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedCustomer"
                      },
                      "name": "copyCustomerData"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "pushCustomerIdToProductForm",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "formData.customer",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "fetchedData.productForm.q.customer"
                      },
                      "name": "pushCustomerIdToProductForm"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getProducts",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/product/search",
                        "arg2Key": "postData",
                        "arg2Value": "fetchedData.productForm",
                        "arg3Key": "storeInVar",
                        "arg3Value": "fetchedData.products"
                      },
                      "name": "getProducts"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.customer.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.product",
                  "label": "Select Product",
                  "disabled": "FALSE",
                  "items": "fetchedData.products.data.docs",
                  "itemText": "productLine",
                  "itemValue": "_id",
                  "formula": "fn(CONCAT,{{__item._id}}, ,fn(HELPER_FN,productAlias,{{__item}}), ({{__item.status}}))",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyProductDetails",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedProductDetails"
                      },
                      "name": "copyProductDetails"
                    },
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySellingUnitArray",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "sourceFn",
                        "arg2Value": "getSellingUnitArray",
                        "arg3Key": "destinationKey",
                        "arg3Value": "fetchedData",
                        "arg4Key": "append",
                        "arg4Value": "TRUE",
                        "arg5Key": "destinationKeyType",
                        "arg5Value": "Object"
                      },
                      "name": "copySellingUnitArray"
                    }
                  ]
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.unit",
                  "label": "Unit",
                  "disabled": "FALSE",
                  "items": "fetchedData.sellingUnits"
                },
                {
                  "type": "input",
                  "variable": "formData.quantity",
                  "label": "Sample Quantity",
                  "unit": "{{formData.unit}}",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.sampleType",
                  "label": "Print Type",
                  "disabled": "FALSE",
                  "items": "[\"Plain\",\"Printed\"]",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.deliverTo",
                  "label": "Delivery To",
                  "disabled": "FALSE",
                  "items": "[\"Sales Office Dammam\",\"Sales Office Riyadh\",\"Sales Office Jeddah\",\"Direct To Customer\"]",
                  "dropdownType": "static" 
                },
                {
                  "type": "dropdown",
                  "variable": "formData.contactPerson",
                  "label": "Select Contact",
                  "disabled": "FALSE",
                  "items": "fetchedData.contact",
                  "itemText": "firstName",
                  "itemValue": "firstName",
                  "formula": "fn(HELPER_FN,contactName,{{__item}})",
                  "showIf": "fn(LOGICAL,fn(CONCAT,',{{formData.deliverTo}},'),==,'Direct To Customer')"
                }
              ]
            },
            {
              "name": "12",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "createSample",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/sample/create",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "storeResponse",
                        "arg3Value": "TRUE"
                      },
                      "name": "createSample"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "redirectToSampleEdit",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/sample/{{__response.data._id}}"
                      },
                      "name": "redirectToSampleEdit",
                      "executeIf": "fn(LOGICAL,{{__response.data._id}},>,-1)"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "secondary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers?showDisabled=true",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customer"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "copyCustomerId",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "__query.customer",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.customer",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Number"
        },
        "name": "copyCustomerId",
        "executeIf": "fn(LOGICAL,{{__query.customer}},>,0)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyProductsForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultProductForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productForm"
        },
        "name": "copyProductsForm"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultSampleType",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultSampleType",
          "arg2Key": "destinationKey",
          "arg2Value": "formData"
        },
        "name": "copyDefaultSampleType"
      }
    ],
    "functions": [
      {
        "name": "getDefaultProductForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {
            "status": ["Draft", "Pending", "Open" ]
          },
          "page": 1
        },
        "staticObject": true
      },
      {
        "name": "getSellingUnitArray",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "sellingUnits": "fn(HELPER_FN,availableSellingUnits,{{__selectedObject.packingMode}})"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultSampleType",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "sampleType": "Plain"
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": false,
  "routerPriority": 88
}